import { useMutation, useQueryClient } from "react-query";
import { loggedInApiCall } from "src/api/axiosClient/userApi";
import { getAllSaml2ProvidersKey, SAML2_PROVIDERS_ENDPOINT } from "./useGetAllSaml2Providers";

export const useDeleteSaml2Provider = () => {
    const queryClient = useQueryClient();

    const query = useMutation({
        mutationFn: async (id: number) => {
            return loggedInApiCall.delete(`${SAML2_PROVIDERS_ENDPOINT}/${id}`);
        },
        onSuccess: () => queryClient.invalidateQueries([getAllSaml2ProvidersKey]),
    });

    return query;
};
